import React from 'react';
import { Flex } from '@stockx/ui';

const CatalogImageWrapper = ({ width, height, children, ...rest }) => (
  <Flex
    width={width}
    height={height}
    maxWidth="100%"
    margin="0px auto"
    justifyContent="center"
    {...rest}
  >
    {children}
  </Flex>
);

export default CatalogImageWrapper;
